import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../utils/alert/alert.utils";
import * as preferencesActions from "./preference.actions";
import * as preferenceSelectors from "./preference.selectors";
export var useGetPreferences = function (key) {
    var dispatch = useDispatch();
    var isFetching = useSelector(function (state) {
        return preferenceSelectors.isFetchingPreferences(state, key) || false;
    });
    var fetchingError = useSelector(function (state) {
        return preferenceSelectors.fetchPreferenceError(state, key);
    });
    var items = useSelector(function (state) {
        return preferenceSelectors.getPreferences(state);
    });
    var fetchPreferences = function () {
        dispatch(preferencesActions.getPreferencesStart.getAction({
            key: key,
        }));
    };
    useEffect(function () {
        if (!key || isFetching) {
            return;
        }
        fetchPreferences();
    }, [key]);
    return {
        items: items,
        isFetching: isFetching,
        fetchingError: fetchingError,
        refetch: fetchPreferences,
    };
};
export var useCreatePreference = function (key) {
    var dispatch = useDispatch();
    var isCreating = useSelector(function (state) {
        return preferenceSelectors.isCreatingPreference(state, key) || false;
    });
    var createError = useSelector(function (state) {
        return preferenceSelectors.createPreferenceError(state, key);
    });
    var fetchPreferences = function () {
        dispatch(preferencesActions.getPreferencesStart.getAction({
            key: key,
        }));
    };
    var createPreference = function (data, onSuccess) {
        dispatch(preferencesActions.createPreferenceStart.getAction({
            data: data,
            onSuccess: function () {
                showAlert({
                    message: "Announcement has been created",
                    type: "success",
                });
                fetchPreferences();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            onFailure: function (error) {
                showAlert({
                    message: error.message || "Announcement creation failed",
                    type: "error",
                });
            },
        }));
    };
    return {
        isCreating: isCreating,
        createError: createError,
        create: createPreference,
    };
};
export var useUpdatePreference = function (key) {
    var dispatch = useDispatch();
    var isUpdating = useSelector(function (state) {
        return preferenceSelectors.isUpdatingPreference(state, key) || false;
    });
    var updateError = useSelector(function (state) {
        return preferenceSelectors.updatePreferenceError(state, key);
    });
    var fetchPreferences = function () {
        dispatch(preferencesActions.getPreferencesStart.getAction({
            key: key,
        }));
    };
    var updatePreference = function (data, onSuccess) {
        dispatch(preferencesActions.updatePreferenceStart.getAction({
            key: key,
            data: data,
            onSuccess: function () {
                showAlert({
                    message: "Announcement has been updated",
                    type: "success",
                });
                fetchPreferences();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            onFailure: function (error) {
                showAlert({
                    message: error.message || "Announcement update failed",
                    type: "error",
                });
            },
        }));
    };
    return {
        isUpdating: isUpdating,
        updateError: updateError,
        update: updatePreference,
    };
};
